<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>I would like to give my special thanks</i></span></p>
<p class="ded1"><span><i>to Minna Jung for her help</i></span></p>
<p class="ded1"><span><i>in the writing of this book.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f4774c58